import { FC } from "react";

export const BulkIcon: FC = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.5 11.98V16.52C18.5 17.93 17.86 18.5 16.27 18.49H12.23C10.64 18.49 10 17.93 10 16.51V11.98C10 10.57 10.64 10 12.23 10H16.27C17.86 10 18.5 10.57 18.5 11.98ZM30 23.73V27.77C30 29.36 29.36 30 27.77 30H23.73C22.14 30 21.5 29.36 21.5 27.77V23.73C21.5 22.14 22.14 21.5 23.73 21.5H27.77C29.36 21.5 30 22.14 30 23.73Z"
      fill="#6A7695"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30 11.98V16.52C30 17.93 29.36 18.5 27.77 18.49H23.73C22.14 18.49 21.5 17.93 21.5 16.51V11.98C21.5 10.57 22.14 10 23.73 10H27.77C29.36 10 30 10.57 30 11.98ZM18.5 23.73V27.77C18.5 29.36 17.86 30 16.27 30H12.23C10.64 30 10 29.36 10 27.77V23.73C10 22.14 10.64 21.5 12.23 21.5H16.27C17.86 21.5 18.5 22.14 18.5 23.73Z"
      fill="#D7DCE9"
    />
  </svg>
);
